export default {"src":"/_next/static/media/phone.a17e1a34.svg","height":66,"width":65};